<section class="flex justify-between items-center mb-6">
  <div class="flex gap-1 items-center">
    <app-icon
      [path]="iconPath()"
      [width]="32"
      [height]="32"
      color="var(--dark-grey)"
    />

    <div class="flex flex-col justify-end gap-0 items-center">
      <h2 class="text-xl text-dark-grey font-medium">{{ title() }}</h2>
    </div>
  </div>

  <app-spinner
    *ngIf="showLoadingSpinner()"
    spinnerSize="24px"
  />
</section>
